export const rutaAPI = "https://portfolio.ngdesignstudio.com";
//export const rutaAPI = "http://localhost:4000";